import React from 'react'
import T from 'prop-types'
import { Box, Button, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import carsToBuyCarImage from 'assets/images/cars-to-buy-car.png'
import theme from 'theme'

export default function InaccessibleSession({
  contentComponent,
  contentProps,
  hideAction,
  actionLabel,
  to,
  actionProps,
  children,
  ...others
}) {
  const Content = contentComponent || Typography

  return (
    <Stack
      alignItems="center"
      sx={{
        width: '50vw',
        m: '0 auto',
        maxWidth: (theme) => theme.spacing(100),
      }}
      data-testid="inaccessible-session"
      {...others}
    >
      <Box mt={10} />
      <Box
        component="img"
        src={carsToBuyCarImage}
        width={0.5}
        maxWidth="350px"
      />
      <Box mt={2} />
      <Content
        variant={contentComponent ? undefined : 'body2'}
        align={contentComponent ? undefined : 'center'}
        {...contentProps}
      >
        {children}
      </Content>

      {!hideAction && (
        <>
          <Box mt={2} />
          <Button
            component={Link}
            to={to}
            size="small"
            variant="contained"
            color="primary"
            {...actionProps}
            style={{
              color: theme.palette.primary.contrastText,
              ...actionProps?.sx,
            }}
          >
            {actionLabel}
          </Button>{' '}
        </>
      )}
    </Stack>
  )
}

InaccessibleSession.propTypes = {
  contentComponent: T.oneOfType([T.object, T.string]),
  contentProps: T.object,
  hideAction: T.bool,
  actionLabel: T.string,
  to: T.string,
  actionProps: T.object,
}
